<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.salesTeamBase$ | async; as salesTeam) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-title-label" translate
                        >SALES_TEAM_LBL_NAME</label
                        >
                        <div class="form-title">{{ salesTeam.name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >SALES_TEAM_LBL_CODE</label
                          >
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              {{ salesTeam.code }}
                            </span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate
                            >SALES_TEAM_LBL_TEAM_LEADER</label
                            >
                            <div class="col">
                              <span class="form-control-plaintext form-control-sm">
                                {{ salesTeam.teamLeaderContactName }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group row">
                            <label class="col-4 col-form-label-sm" translate
                              >SALES_TEAM_LBL_ACTIVE</label
                              >
                              <div class="col">
                                <span class="form-control-plaintext form-control-sm">
                                  <input
                                    type="checkbox"
                                    name="active"
                                    [(ngModel)]="salesTeam.active"
                                    onclick="return false;"
                                    disabled
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <app-sales-team-tabs-details />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (this.salesTeamBase$ | async; as salesTeam) {
                <div class="col-comment">
                  <app-comment-panel
                    [entityType]="'SalesTeam'"
                    [entityId]="salesTeam.id.toString()"
                  ></app-comment-panel>
                </div>
              }
            </div>
          </div>
